module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (34).ee1d1466.png";